/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 *
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 *
 * Software credits:
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 *
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

export const MESSAGES = {
  commons: {
    register: 'Register',
    login: 'Log In',
    dashboard: 'Dashboard',
    admin: 'Admin',
    cancel: 'Cancel',
    submit: 'Submit',
    edit: 'Edit',
    create: 'Create',
    conversationHistory: 'Improve the conversation',
    manageBot: 'Manage the Bot',
    domains: 'Domains',
    intents: 'Intents',
    lastTraining: 'Last analysis',
    analysisReport: 'Analysis report',
    newRelease: 'New Release',
    releaseHistory: 'Release History',
    releases: 'Releases',
    botManagement: 'BOT Management',
    listOfAvailableReleases: 'List of available releases',
    flows: 'Flows Management',
    botConnection: 'Bot Settings',
    vdnSettings: 'VDN Settings',
    darkZone: 'Tech Zone',
    support: 'Support',
    notFound404: 'Not found 404',
    score: 'Score',
    linkMoreInfo: 'See detail',
    fieldRequired: 'is required', // Concat the Input before this message
    confirm: 'Confirm',
    notFoundTitle: 'Oups! Something went wrong :(',
    notFondText: `We are having some technical problems and the information couldn’t be loaded.
    Please try again in a few minutes or contact Dani at daniel.garcia@axa.com to fix it.`,
    tooltipWidget: 'Test the Intents',
    trainStatusPending: 'There are intents pending to be trained',
    trainingStatus: 'Training intents',
    trainStatusOK: 'All intents are trained',
    analysisStatusPending: 'There are intents pending to be analyzed',
    analyzingStatus: 'Analyzing intents',
    analysisStatusOK: 'All intents are analyzed',
    importIsStatusPending: 'Import in progress...',
    importStatusOK: 'All intents were imported successfuly',
    importStatusKO: 'There was an error during import. Keeping previous corpus.',
    yes: 'Yes',
    no: 'No',
    noData: 'No Data',
    users: 'users',
    none: 'None',
    loading: 'loading...',
    filtersArea: {
      title: 'Applied filter',
      domain: 'Domain',
      intent: 'Intent',
      occurrences: 'conversations',
      fromDate: 'From date',
      toDate: 'To date',
      btnClearFilters: 'Clear filters',
    },
    confidence: 'Confidence',
    unauthorized: 'Unauthorized',
  },
  register: {
    robotImgAlt: 'Drawed Robot floating',
    nlpImgAlt: 'AXA Bots logo a bubble with 3 dots inside',
    title: 'AXA Bots',
    userInput: 'Name',
    emailInput: 'Email',
    passwordInput: 'Password',
  },
  users: {
    name: 'Name',
    permit: 'Permit',
    newUserTitle: 'New User',
    editUserTitle: 'Edit User',
    formUserName: 'User name',
    formUsersPermit: 'User permits',
    formInputUserPlaceholder: 'Need to be an valid Axa identifier',
  },
  login: {
    robotImgAlt: 'Drawed Robot floating',
    nlpImgAlt: 'AXA Bots logo a bubble with 3 dots inside',
    title: 'AXA Bots',
    emailInput: 'User',
    passwordInput: 'Password',
    register: 'Register',
    activate: 'Activate account',
    unauthorized: 'You are not authorized',
    unAuthorizedContent: 'Please ask the admin to assign you permits',
  },
  header: {
    title: 'User Navigation',
    logout: 'Log out',
    primaryNavigation: 'Primary navigation',
    btnTrainBot: 'Train the bot',
    btnUploadFiles: 'Upload Bot Data File(s)',
  },
  alerts: {},
  dashboard: {
    cardTopUsedTitle: 'Top 5 used intents',
    cardUsageEvolutionTitle: 'Usage evolution',
    cardCorpusTitle: 'Content performance',
    cardDialogsTitle: 'Dialogs Chart',
    linkTopUsers: 'See intents by usage',
    messages: 'Messages',
    users: 'Users',
    hits: 'Hits',
    misses: 'Misses',
    kpiTotalUsers: 'Total users',
    kpiNewUsers: 'New users',
    kpiReturningUsers: 'Returning users',
    kpiMessagesByConversation: 'Messages by conversation',
    kpiUnusedIntents: 'Unused intents',
    kpiMissedMessages: 'Missed messages',
    kpiUserComplaints: 'Negative feedback',
    kpiLowAccuracy: 'Intents with low accuracy',
    kpiOverallAccuracy: 'Overall accuracy',
    filterDomainPlaceholder: 'Select a filter by domain',
    filterDatePlaceholder: 'Filter by date:',
    all: 'See all',
    today: 'Today',
    yesterday: 'Last 2 days',
    lastWeek: 'Last week',
    last2Weeks: 'Last 2 weeks',
    lastMonth: 'Last month',
    last6Months: 'Last 6 months',
    lastYear: 'Last year',
    currentRelease: '(live release)',
  },
  manageBot: {
    saveVersionModal: {
      createVersion: 'Create Version',
    },
    manageBotNavigation: 'Manage the Bot navigation',
    listDomainsTitle: 'List of Domains',
    newDomainTitle: 'New Domain',
    editDomainTitle: 'Edit Domain',
    seeDomainTitle: 'Domain',
    seeIntentTitle: 'Intent',
    newIntentTitle: 'New Intent settings',
    editIntentTitle: 'Edit Intent settings',
    listIntentsTitle: 'List of Intents',
    btnNewDomain: 'Add new domain',
    btnNewIntent: 'Add new intent',
    btnforkFlowsVersion: 'Copy flows to draft',
    btnforkIntentsVersion: 'Copy corpus to draft',
    btnSaveFlowsVersion: 'Save Flows version',
    btnSaveCorpusVersion: 'Save Corpus version',
    draft: 'Draft',
    corpus: 'Corpus',
    formBotConnectionContent: 'Connection settings',
    formBotSettingsContent: 'Bot settings',
    formSaveChanges: 'Save changes',
    formInputBotSettingsContentPlaceholder: 'Add here the connection settings',
    btnNewFlow: 'Add new flow',
    formFlowName: 'Flow name',
    formFlowContent: 'Flow content',
    newFlowTitle: 'Create Flow',
    editFlowTitle: 'Edit Flow',
    formInputFlowPlaceholder: 'Type a name for your Flow',
    formInputFlowContentPlaceholder: 'Flow content. Example:\ndialog main\n  nlp',
    btnEditFlow: 'Edit flow',
    btnCreateFlow: 'Create flow',
    searchDomainPlaceholder: 'Search by domain name',
    searchIntentPlaceholder: 'Search by intent name or example',
    invalidSearch: 'Your search must contains at least 3 characters',
    tableDomainName: 'Domain name',
    tableDomainToolTipLabel: 'List of main categories',
    tableDomainPopConfirmText: 'Sure to delete this domain? It will remove related intents too.',
    tableIntentName: 'Intent name',
    tableFlowName: 'Flow name',
    listFlowsTitle: 'List of Flows',
    tableLanguage: 'Language',
    tableIntentsNumber: 'Number of intents',
    tableSeeIntents: 'Link to Intents',
    tableIntentsLink: 'see intents in this domain',
    tableIntentActive: 'Intent is active, it will be included in train the bot',
    tableIntentInactive: 'Intent is unactive and it will not be included in train the bot',
    tablePriority: 'Priority',
    tableAskFeedback: 'Ask feedback',
    tableExamples: 'Examples',
    tableLastTrainingSummaryText: 'Total issues',
    formDomainName: 'Domain name',
    formInputDomainPlaceholder: 'Type a name for your domain',
    formDomainLanguage: 'Domain language',
    formSelectLanguagePlaceholder: 'Select a language',
    btnCreateDomain: 'Create domain',
    btnEditDomain: 'Edit domain',
    btnCreateIntent: 'Create intent',
    btnEditIntent: 'Edit intent',
    btnCancel: 'Cancel',
    btnAdd: 'Add',
    formSelectDomain: 'Select domain',
    formSelectDomainPlaceholder: 'Existing domain',
    formInputIntent: 'Intent name',
    formatNameInfo: 'Only lower case letters, numbers, - and _ are allowed',
    textLengthMessage: 'text length exceeded',
    formInputIntentPlaceholder: 'Type a name for your intent',
    formIntentName: 'The intent name is:',
    formInputDescription: 'This intent answers a question about....',
    formInputDescriptionTooltip:
      "The bot will use this description to ask for the user's confirmation. Example: Do you mean you want to find the HR phone number?",
    formInputDescriptionPlaceholder: 'Do you mean you want...',
    formSwithEnableIntent: 'Select Intent status',
    formSwithEnableIntentTooltip:
      'If the intent is not active it will not be trained in the conversation and the Bot will not be able to answer.',
    formSwithAskFeedback: 'Request user feedback',
    formSwithAskFeedbackTooltip:
      'If active, the bot will ask the user to confirm they got the correct answer to their question.',
    formSwithNegativeFeedback: 'Negative feedback',
    formSwithNegativeFeedbackTooltip:
      'Select negative feedback only for intents created to detect a user’s negative mood.',
    formSelectPriority: 'Priority level',
    formSelectPriorityTooltip:
      'The intent priority will help easily detect should be first corrected after the testing.',
    formSelectPriorityPlaceholder: 'Select a level of priority',
    formIntentSectionTitle: 'New intent content',
    formUserSentences: 'User sentences and questions',
    formUserSentencesPlaceholder: 'Type the examples of sentences or questions that a user might say to the bot',
    formUserTests: 'Acceptance tests',
    formUserTestsTooltip:
      'Validate the Bot performance with examples not used in training in order to improve the content.',
    formBotAnswers: 'Bot answers',
    formBotAnswersPlaceholder: 'Type the of answers that the bot will give',
    formBotAnswersTagsPlaceholder: 'Select a tag to adjust the answer',
    noDomainsTitle: 'Your bot has no domains yet!',
    noDomainsText: `Domains are the big groups of information used to group and manage the chatbot content.
    For example, in a public library chatbot a domain could be "horror-books" or "author-information".
    Each specific topic inside a domain is called an Intent. You can start adding intents only after you have created a domain to group them.`,
    noDomainsCTA: 'create your first domain',
    noIntentsTitle: 'Your bot has no intents yet!',
    noIntentsText: `An intent is every topic the chatbot can talk about. So if you have a chatbot for a public library an intent will be LittleLadies-writer or 1984-publicatonDate.
    Each intent will have at least an answer to return to the user, like : "Little women was written by Louisa May Alcott" or "1984 was published in 1949".`,
    noIntentsCTA: 'create your first intent',
    noFlowsTitle: 'Your bot has no Flows in draft',
    noFlowsText: `A flow is a set of dialogs that help you build conversational flows`,
    noFlowsCTA: 'create new flow',
    ago: 'ago',
    errorsDetected: 'Errors detected during analysis',
    typeError: 'Type of error',
    suggestionSimilarity:
      'Make sentences less similar. The chatbot needs diversity of sentences to train for all possible cases.',
    equivalent_utterances: [
      'In the intent ',
      '[intent0]',
      ', the utterance ',
      '[utterance0]',
      ' and the utterance ',
      '[utterance1]',
      ' are too similar. Repetitions do not improve the accuracy of the bot, but it will cause missclassifications between intents. ',
      'Solution: Remove one of the repeated utterances.',
    ],
    // Old: 'In the intent [intent0], the utterance [utterance0] is equivalent to [utterance1]. You should consider removing one of them.',
    // In the intent [intent 1], the utterance [utterance 1] and the utterance [utterance 2] are too similar. Repetitions do not improve the accuracy of the bot, but it will cause missclassifications between intents.
    // Solution: Remove one of the repeated utterances.
    equivalent_utterances_different_intents: [
      'The utterance ',
      '[utterance0]',
      ' from the intent ',
      '[intent0]',
      ' is too similar to ',
      '[utterance1]',
      ' from the intent ',
      '[intent1]',
      ' which could confuse the bot. ',
      'Solution: Delete one of the utterances or make them more different.',
    ],
    // Old: 'The utterance [utterance0] of the intent [intent0] is equivalent to [utterance1] of the intent [intent1]. Please, differentiate your content to avoid missclassifications.',
    // The utterance [a] from the intent [1] is too similar to the utterance [b] from the itnent [2] which could confuse the bot.
    // Solution: Delete one of the utterances or make them more different.
    not_enough_utterances: [
      'The ',
      ' intent ',
      '[intent0]',
      ' with ',
      '[priority]',
      ' priority, has ',
      '[utterances]',
      ' utterances, but the minimun defined for a correct accuracy is ',
      '[definedUtterances]',
      '. Solution: Add more utterances to the intent.',
    ],
    // Old: 'The intent [intent0] (that has [priority] priority), has only [utterances] utterances and the minimun is [definedUtterances]. Add more utterances to it.',
    // The [priority] intent [1] has [N] utterances, but the mimum defined for a correct accuracy is [10].
    misclassified: [
      'The utterance ',
      '[utterance0]',
      ' from the intent ',
      '[intent0]',
      ' is too similar to the utterance from the intent ',
      '[collisionIntent]',
      ' which will cause a missclasification and a wrong answer. ',
      'Solution: Delete or modify one of the utterances, or merge both intents into one, otherwise, consider creating a flow.',
    ],
    // Old: 'The utterance [utterance0] of the intent [intent0] was classified as the intent [secondClassification]. Please, differentiate your content to fix the missclassification.',
    // The utterance [a] from the intent [1] is too similar to the utterance [b] from the itnent [2] which will cause a missclasification and a wrong answer.
    // solution: Delete or modify one of the utterances, or merge both intents into one, otherwise, consider [creating a flow]
    low_score: [
      'The utterance ',
      '[utterance0]',
      ' from the intent ',
      '[intent0]',
      ' is too similar to the utterance ',
      '[collisions]',
      ' from the intent ',
      '[collisionIntent]',
      '. This means that the bot does not have enough information to select an answer.',
      ' Solution: Delete or modify one of the utterances, or merge both intents into one, otherwise, consider creating a flow.',
    ],
    // Old: 'In the intent [intent0], the utterance [utterance0] has low accuracy as it is quite similar to utterance [collisions] in intent [collisionIntent]. You may want to edit or remove this utterance.'
    // The utterance [a] from the intent [1] is too similar to the utterance [b] from the itnent [2] .This means that the bot does not have enough information to select an answer.
    // Solution: Delete or modify one of the utterances, or merge both intents into one, otherwise, consider [creating a flow]
    low_quality: [
      'The utterance ',
      '[utterance0]',
      ' from the intent ',
      '[intent0]',
      ' is too similar to the utterance ',
      '[collisions]',
      ' from the intent ',
      '[collisionIntent]',
      '. This means that the bot does not have enough information to select an answer.',
      ' Solution: Delete or modify one of the utterances, or merge both intents into one, otherwise, consider creating a flow.',
    ],
    releasesPage: {
      createFlowsVersionSubtitle: 'Create a new Flow version',
      createCorpusVersionSubtitle: 'Create a new Corpus version',
      newRelease: 'New Release',
      corpusVersion: 'Corpus version',
      flowsVersion: 'Flows version',
      releaseName: 'Release name',
      markAsStable: 'Stable Release',
      markToTestTitle: 'Release to test',
      deleteCorpusVersionSubtitle: 'Delete an existing version',
      deleteFlowReleaseSubtitle: 'Delete an existing flow version',
      formFlowReleaseTitle: 'Version flow title',
      formFlowReleaseDescription: 'Version flow description',
      formFlowReleaseDescriptionPlaceholder: 'Aim of the flows, with which corpus suits well...',
      formReleaseDescription: 'Version description',
      formReleaseDescriptionMessage: 'Please input the description',
      formatReleaseNameMessage: 'Please add a name for this release',
      formReleaseNamePlaceholder: 'Add a release name',
      btnCreateRelease: 'Create Corpus Version',
      btnCreateFlowVersion: 'Create Flow Version',
      btnDeleteFlowVersion: 'Delete Flow Version',
      btnDeleteRelease: 'Delete Version',
      btnDeleteFlowVersionPlaceholder: 'Removes a flow version from axabots',
      formDeleteReleasePlaceholder: 'Removes a corpus version from axabots',
      btnCreateReleaseExplanation: '(it creates an snapshot of the current training)',
      btncreateFlowsVersionExplanation: '(it creates an snapshot of the current flows)',
      configurationTitle: 'Configuration',
      contentCorpusTitle: 'Manage Corpus data',
      formSelectStableReleasePlaceholder: 'Select the most stable release',
      formSelectReleaseMessage: 'Please select a release',
      btnSetStableRelease: 'Set stable release',
      btnAddRelease: 'Add release',
      btnOpenRealBot: 'Open real Bot',
      btnGoToLiveRelease: 'Go to Live release',
      switchNotify: 'Send to bot',
      formSelectFlowReleasePlaceholder: 'Select a flow version to be loaded',
      formSelectReleasePlaceholder: 'Select a corpus version to be loaded',
      btnLoadInTest: `Load in 'Test the Bot'`,
      btnExportCorpus: 'Export',
      btnImportCorpus: 'Import',
    },
  },
  conversationHistory: {
    conversationHistoryNavigation: 'Conversation History navigation',
    conversationHistoryTitle: 'Conversation History',
    byMessage: 'By Message',
    byIntent: 'By Intent',
    byIntentSubtitle: 'Ranking of Intents usage',
    modalTitle: 'Chatbot conversation',
    modalSubtitle: 'Does my invoices have to follow a format?',
    modalAnswerSubtitle: '(invoice.en.invoiceFormat, 0.95)',
    endConversation: 'End of conversation',
    tableUsersMessages: 'Users messages',
    tableDomainName: 'Domain name',
    tableIntentName: 'Intent name',
    tableLanguage: 'Language',
    tableDomain: 'Domain',
    tableScore: 'Score',
    tableStatus: 'Status',
    tableDate: 'Creation date',
    tableIntent: 'Intent',
    tableMostRepeated: 'Most repeated',
    linkSeeConversation: 'See conversation',
    test: 'test',
    occurrences: 'conversations',
    chatbot: 'chatbot',
    nlpTest: 'NLP test',
    btnExportMessage: 'Export Conversations',
    modalReassignIntent: {
      noTitle: 'no title',
      checkIntentTitle: 'CHECK INTENT',
      fixIntentTitle: 'FIX INTENT',
      btnCreateNewIntent: 'Create new Intent',
      btnCopy: 'Copy',
      message: 'Message:',
      assignMessage: 'Bot assigned message to:',
      previouslyAssigned: 'Previously assigned to:',
      currentlyAssigned: 'Currently assigned to:',
      by: 'by',
      on: 'on',
      assignTo: 'Assign to:',
      currenIntents: 'Current intents:',
      error: 'You need assign to an intent or Cancel',
    },
  },
};
